import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { connect } from "react-redux";

import Footer from '../Footer';
import Header from '../Header';
import Information from './Information';
import Integration from './Integration';

import { servicePage, userMenu } from '../../../Constants/user';

import './services.scss';

class Services extends PureComponent {
    constructor(props) {
        super(props);

        let firstLang = props.lang || 'arm';
        props.active(1);

        let language = servicePage.find(el => el.lang === firstLang);

        document.title = language.title;

        this.state = {
            language,
            lang: props.lang,
            initialized: true,
        };
    }

    componentDidMount () {
        axios.post('/api/services/getAll').then(({ data }) => {
            this.setState({
                services: data.result,
            })
        })
    }

    static getDerivedStateFromProps(props, state) {
        let language = servicePage.find(el => el.lang === props.lang);

        document.title = language.title;

        return {
            language,
            lang: props.lang,
            initialized: true,
        }
    }

    render() {
        if(!this.state.initialized) return null;

        const {
            language,
            language: {
                offer,
                informationList,
                integrationList,
                informationText,
                integrationText,
            }
        } = this.state;
        const { width, setLanguage, language: propsLanguage, activeMenu } = this.props;

        return (
            <div id={'servicePage'}>
                <div id={'left'}>
                    {width > 1024 ? (
                        <Link to={'/'}><img src={'/images/userPage/desktop/Logo for web.png'} alt /></Link>
                    ) : (
                        <Link to={'/'}><img src={'/images/userPage/tablet/Logo2.png'} alt /></Link>
                    )}
                </div>
                <div id={'right'}>
                    <Header
                        userMenu={userMenu}
                        active={activeMenu}
                        language={propsLanguage}
                        setLanguage={setLanguage}
                    />
                    <div id={'container'}>
                        <div id={'containerInner'}>
                            <div id={'textPart'}>
                                <div id={'offer'}>{offer}</div>
                                <Information
                                    infoList={informationList}
                                    informationText={informationText}
                                />
                                <Integration
                                    integrationList={integrationList}
                                    integrationText={integrationText}
                                />
                            </div>
                            <Footer language={language.lang} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = ({ main: { width } }) => ({
    width,
});

export default connect(mapStateToProps)(Services);
